import React from "react";

// Import Components
import Header from "./Header";
import Appointment from "./Appointment";

//Import Lawyer Image
import LawyerImage from "../assets/img/lawyer_banner3.png";

const Banner = () => {
  return (
    <section
      id="home"
      className="lg:h-full lg:max-h-800 bg-gradient-to-t from-[#f8f3ec] to-[#e0c8ac]"
    >
      <Header />
      <div className="container mx-auto h-full lg:flex pt-32">
        {/*left side */}
        <div className="text-center mx-auto h-full lg:text-left px-8 md:p-0">
          <h1 className="font-primary font-black text-6xl lg:text-7xl text-primary mb-4 lg:mt-[70px] leading-tight lg:leading-[90px]">
            Strategy. Protection.
            <br /> <span className="text-accent"> Peace of Mind.</span>
          </h1>
          <p className="max-w-sm mx-auto mb-[50px] lg:mx-0 lg:max-w-[540px]">
            Legal services designed to safeguard your name, brand, and business.
          </p>
          {/* Appointment */}
          <div className="lg:absolute mx-auto max-w-[445px] lg:mx-0">
            <Appointment />
          </div>
        </div>
        {/* right side */}
        <div className="hidden flex-1 lg:flex lg:flex-col items-end">
          <img
            src={LawyerImage}
            alt=""
            className="object-contain w-full max-h-[500px] -mt-8 lg:max-h-[600px] mx-auto"
          />
        </div>
        
      </div>
    </section>
  );
};

export default Banner;
